<dialog #notificationDialog>
  <div class="container">
    <ion-toolbar>
      <ion-button slot="end" fill="clear" (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-toolbar>

    <div class="content">
      <ng-lottie height="180px" [options]="options"></ng-lottie>
      <h4 class="title">{{ 'notificationmodal1' | translate }}</h4>
      <p>{{ (isCasino ? 'notificationmodalcasino' : 'notificationmodal2') | translate }}</p>

      <div class="buttons">
        <ion-button expand="block" class="btn-primary" (click)="goToSettings()"
          >{{ 'gotoconfig' | translate }}</ion-button
        >
        <ion-button fill="clear" class="btn-secondary" (click)="close()">{{ 'nothanks' | translate }}</ion-button>
      </div>
    </div>
  </div>
</dialog>
